import { render, staticRenderFns } from "./RichContentMediaText.vue?vue&type=template&id=341728a2&"
import script from "./RichContentMediaText.vue?vue&type=script&lang=js&"
export * from "./RichContentMediaText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports